import React from 'react';
import { Modal, Form, Button } from 'antd';

const FormModal = ({ 
  title, 
  open, 
  onCancel, 
  onSubmit, 
  form, 
  children, 
  width = 600,
  confirmLoading = false,
  okText = 'Submit',
  cancelText = 'Cancel'
}) => {
  return (
    <Modal
      title={title}
      open={open}
      onCancel={onCancel}
      footer={null}
      width={width}
      confirmLoading={confirmLoading}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={onSubmit}
        requiredMark={false}
      >
        {children}
        
        <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end', marginTop: '16px' }}>
          <Button onClick={onCancel}>
            {cancelText}
          </Button>
          <Button 
            type="primary" 
            htmlType="submit"
            loading={confirmLoading}
            style={{ 
              background: '#40a9ff', 
              borderColor: '#40a9ff' 
            }}
          >
            {okText}
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default FormModal;
